import React from 'react';
import { FadeIn } from './FadeIn';
export function ValueStack() {
  const items = [{
    icon: '📖',
    title: 'Guía Principal — 60 Láminas',
    desc: 'Los 7 capítulos completos con el sistema semana a semana',
    value: 'Core'
  }, {
    icon: '🗂️',
    title: 'Tabla de Ventanas de Sueño por Edad',
    desc: 'Referencia rápida para saber cuándo acostar a tu bebé en cada etapa',
    value: 'Incluido'
  }, {
    icon: '📋',
    title: 'Lista de Señales de Sueño Tempranas',
    desc: 'Para actuar antes del llanto — laminita que puedes poner en la pared',
    value: 'Incluido'
  }, {
    icon: '🌙',
    title: 'Rutina de Pre-Sueño en Una Página',
    desc: 'Los 4 pasos en formato visual para tenerlo siempre a mano',
    value: 'Incluido'
  }, {
    icon: '🚨',
    title: 'Protocolo de Emergencia Nocturna',
    desc: 'Qué hacer cuando estás al límite y no sabes qué más intentar',
    value: 'Incluido'
  }, {
    icon: '✅',
    title: 'Checklist de Diagnóstico de Bloqueos',
    desc: 'Para identificar exactamente qué está impidiendo el progreso de tu bebé',
    value: 'Incluido'
  }];
  return <section className="bg-white py-24 px-6" data-id="element-397">
      <div className="max-w-4xl mx-auto" data-id="element-398">
        <FadeIn data-id="element-399">
          <h2 className="text-3xl md:text-4xl font-bold text-azul-noche mb-12 text-center" data-id="element-400">
            Lo que obtienes cuando accedes hoy
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-401">
          <div className="bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden mb-8" data-id="element-402">
            <div className="divide-y divide-gray-100" data-id="element-403">
              {items.map((item, index) => <div key={index} className="flex flex-col sm:flex-row items-start sm:items-center p-6 hover:bg-crema/20 transition-colors" data-id="element-404">
                  <div className="text-3xl mr-6 mb-4 sm:mb-0 bg-crema w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-405">
                    {item.icon}
                  </div>
                  <div className="flex-grow" data-id="element-406">
                    <h3 className="font-bold text-azul-noche text-lg" data-id="element-407">
                      {item.title}
                    </h3>
                    <p className="text-texto text-sm mt-1" data-id="element-408">{item.desc}</p>
                  </div>
                  <div className="mt-4 sm:mt-0 sm:ml-6 flex-shrink-0" data-id="element-409">
                    <span className={`px-4 py-1.5 rounded-full text-sm font-bold ${item.value === 'Core' ? 'bg-azul-noche text-white' : 'bg-lila-suave/30 text-azul-noche'}`} data-id="element-410">
                      {item.value}
                    </span>
                  </div>
                </div>)}
            </div>
            <div className="bg-azul-noche text-white p-6 text-center" data-id="element-411">
              <p className="text-lg font-medium" data-id="element-412">
                Todo. Digital. Acceso inmediato. Disponible en tu teléfono a las
                3am cuando más lo necesites.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}